<template>
    <div class="forex-index">
        <page-navigate></page-navigate>

        <div class="forex-wrapper cn">
            <forexMenu />
            <div class="forex-wrapper-body">
                <div id="search-box-index">
                    <div class="ebc-tabs no-scrollbar">
                        <a href="/jinrong/ebc-ea-turbo/" class="ebc-tab-line-item">
                            EBC turbo
                        </a>
                        <a href="javascript:;" class="ebc-tab-line-item ebc-tab-line-item-selected">
                            其他EA插件
                        </a>
                    </div>
                </div>
                <section class="section1">
                    <h1 class="">高效实用的EA插件工具</h1>
                    <div class="forex-title-intro">
                        精选热门EA交易插件，包括盈亏统计、行情推送、定时下单等功能，一键注册免费领取，助您构建更高效、更智能的交易环境。
                    </div>
                    <div class="forex-btn-group">
                        <ebc-btn class="ebc-btn">立即获取</ebc-btn>
                    </div>

                    <div class="ea-intro-list">
                        <div class="ea-intro-li">
                            <img class="ea-turbo-banner" src="../../assets/image/forex/tools/ea_bg1.jpg" alt="" />
                            <div class="ea-intro-li-content">
                                <p class="ea-intro-li-label">同图商品叠加工具</p>
                                帮助投资者通过叠加两个商品的走势，分析它们之间的低阻力线强弱，识别出关键的突破点，提升决策准确性。
                            </div>
                        </div>
                        <div class="ea-intro-li">
                            <img class="ea-turbo-banner" src="../../assets/image/forex/tools/ea_bg2.jpg" alt="" />
                            <div class="ea-intro-li-content">
                                <p class="ea-intro-li-label">MACD专业指标(双线)</p>
                                提供比普通MACD更为精准的双线指标，帮助投资者更好地识别市场的买卖信号，从而捕捉更佳的盈利机会。
                            </div>
                        </div>
                        <div class="ea-intro-li">
                            <img class="ea-turbo-banner" src="../../assets/image/forex/tools/ea_bg3.jpg" alt="" />
                            <div class="ea-intro-li-content">
                                <p class="ea-intro-li-label">MTDriver盈亏统计指标</p>
                                该指标可协助投资者实时统计不同周期内的盈亏情况，为制定更精准的交易策略提供数据支持。
                            </div>
                        </div>
                        <div class="ea-intro-li">
                            <img class="ea-turbo-banner" src="../../assets/image/forex/tools/ea_bg4.jpg" alt="" />
                            <div class="ea-intro-li-content">
                                <p class="ea-intro-li-label">价格变动手机推送通知</p>
                                实时监控市场价格波动，当出现重大变动时，立即向投资者的手机发送推送通知，确保他们能够在关键时刻做出迅速反应。
                            </div>
                        </div>
                        <div class="ea-intro-li">
                            <img class="ea-turbo-banner" src="../../assets/image/forex/tools/ea_bg5.jpg" alt="" />
                            <div class="ea-intro-li-content">
                                <p class="ea-intro-li-label">定时下单EA软件</p>
                                通过MT4 EA 、MT5 EA与外汇EA预设时间自动执行订单，无需人工干预，适合在特定时间点进行交易的策略，确保交易的及时性与准确性。
                            </div>
                        </div>
                        <div class="ea-intro-li">
                            <img class="ea-turbo-banner" src="../../assets/image/forex/tools/ea_bg6.jpg" alt="" />
                            <div class="ea-intro-li-content">
                                <p class="ea-intro-li-label">净值监控EA</p>
                                实时监控账户的净值变化，当净值达到预设的阈值时自动触发警报，帮助投资者及时应对潜在的风险，保障资金安全。
                            </div>
                        </div>
                        <div class="ea-intro-li">
                            <img class="ea-turbo-banner" src="../../assets/image/forex/tools/ea_bg7.jpg" alt="" />
                            <div class="ea-intro-li-content">
                                <p class="ea-intro-li-label">一键平仓EA</p>
                                操作界面位于图表界面中，方便投资者在极端行情发生的时候更迅速便捷地进行止损。减少操作风险，提高交易效率。
                            </div>
                        </div>
                    </div>

                </section>
            </div>
        </div>

        <page-footer></page-footer>
    </div>
</template>
<script>
import forexMenu from '../../components/forex-menu/forex-menu.vue';


export default {
    components: {
        forexMenu
    },
    mounted() {
      
    }
}
</script>

<style>
    body{
        font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
    }
</style>
<style scoped>
@import url("../../assets/css/forex/rem.css");
@import url("../../assets/css/forex/common.css");
@import url("../../assets/css/forex/forex-tool.css");

.forex-index {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}
</style>